module.exports = __webpack_public_path__ + "static/media/team11.ee8bfcdb.jpg";